import BasicContainersQuery from "./basic_containers";

export default [...BasicContainersQuery];
